export default __webpack_public_path__ + "43ebc2014d52946f20dd09db25f57dc0.png";